<div class="page-header">
  <div class="header-start">
    <h3 class="title">Applications & Resources</h3>
  </div>
  <div class="header-end">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
      <li class="breadcrumb-item inactive"><a class="link" style="cursor: pointer;" (click)="navigateToApplicationsList()">Applications</a></li>
      <li class="breadcrumb-item active"><span>{{applicationData.info.resourceName | titlecase}}</span></li>
      </ol>
  </nav>
  </div>
</div>

<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a class="link" style="cursor: pointer;"
        (click)="navigateToApplicationsList()">Applications</a></li>
    <li class="breadcrumb-item active"><span>{{applicationData.info.resourceName | titlecase}}</span></li>
  </ol>
</nav>


<form #f="ngForm" autocomplete="off">
  <div class="row g-4">
    <div class="col-lg-3">
      <mat-form-field class="w-100">
        <mat-label>Resource Name</mat-label>
        <input matInput placeholder="Resource Name" readonly [value]="applicationData.info.resourceName">
      </mat-form-field>

    </div>
    <div class="col-lg-3">
      <mat-form-field class="w-100">
        <mat-label>Resource Type</mat-label>
        <input matInput placeholder="Resource Type" readonly [value]="applicationData.type">
      </mat-form-field>

    </div>
    <div class="col-lg-3">

      <mat-form-field class="w-100">
        <mat-label>Date Created</mat-label>
        <input matInput placeholder="Date Created" readonly
          [value]="applicationData.info.createdTs | date : 'dd MMM y'">
        <!-- <mat-icon matSuffix>today</mat-icon> -->
      </mat-form-field>
    </div>
    <div class="col-lg-3">
      <mat-form-field class="w-100">
        <mat-label>Application Name</mat-label>
        <input matInput placeholder="Application Name" readonly [value]="applicationData.info.applicationName">
      </mat-form-field>
    </div>
  </div>

  <mat-card class="mb-4">
    <mat-card-header>
      <mat-card-title>Assign Resource</mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <mat-divider class="my-3"></mat-divider>
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills mb-3">
        <li [ngbNavItem]="1">
          <a ngbNavLink mat-raised-button>Customers</a>
          <ng-template ngbNavContent>


            <div class="row g-3">
              <div class="col-12">
                <div class="row">
                  <ng-container *ngIf="!isCustomer">
                    <div class="col-md-6 col-xl-3">
                      <ng-select class="" name="customerList" [items]="customerTableData" placeholder="Search Customers"
                        bindLabel="customerName" [closeOnSelect]="true" (change)="onCustomerSelect($event)"
                        (clear)="clearCustomerOptions()" [multiple]="true">
                      </ng-select>
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngFor="let cust of customerTableDataCopy ; let i = index">
                <div class="col-xl-3 col-sm-6 ">
                  <mat-checkbox class="example-margin" [id]="buildLabel(i)" [name]="cust.customerName + i"
                    [(ngModel)]="cust.assigned"
                    (click)="toggleCustomerResourceAllocationMap(cust.customerId)">{{cust.customerName}}</mat-checkbox>

                </div>
              </ng-container>
            </div>

            <!-- <div class="float-end gap-3 d-flex">
              <button type="button" (click)="navigateToApplicationsList()" class="btn btn-secondary rounded-pill">Back
              </button>
              <button type="button" *ngIf="!isUserCustomerServiceExecutive" (click)="submitCustomers()"
                class="btn btn-primary rounded-pill" [disabled]="!isCustomerSubmitButtonEnabled">Submit
              </button>
            </div> -->
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink mat-raised-button>Roles</a>
          <ng-template ngbNavContent>
            <div class="row g-3">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6 col-xl-3 mt-3">
                <ng-select class="" name="roleList" [items]="rolesTableData" placeholder="Search Roles"
                  bindLabel="roleName" [closeOnSelect]="true" (change)="onRoleSelect($event)"
                  (clear)="clearRoleOptions()" [multiple]="true">
                </ng-select>
              </div>
                </div>
              </div>
              <ng-container *ngFor="let role of rolesTableDataCopy; let i = index">
                <ng-container *ngIf="!isUserCustomerServiceExecutive">
                  <div class="col-xl-3 col-sm-6 ">
                    <mat-checkbox class="example-margin" [id]="buildLabel(i)"
                    [name]="role.roleName + i" [(ngModel)]="role.isAssigned"
                    (click)="toggleRoleResourceAllocationMap(role.roleId)">{{role.roleName}}</mat-checkbox>
  
                  </div>
                </ng-container>
                
              </ng-container>
            </div>
       
            <!-- <div class="float-end gap-3 d-flex">
              <button type="button" (click)="navigateToApplicationsList()" class="btn btn-secondary rounded-pill">Back
              </button>
              <button type="button" *ngIf="!isUserCustomerServiceExecutive" (click)="submitRoles()"
                class="btn btn-primary rounded-pill" [disabled]="!isRoleSubmitButtonEnabled">
                Submit
              </button>


            </div> -->
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="p-0 border-0"></div>

    </mat-card-content>
    <mat-card-actions class="d-flex justify-content-end gap-3">
      <button mat-raised-button (click)="navigateToApplicationsList()">Back</button>
      <button mat-raised-button color="primary" *ngIf="!isUserCustomerServiceExecutive && active == 2" (click)="submitRoles()"
        [disabled]="!isRoleSubmitButtonEnabled">Submit</button>
      <button mat-raised-button color="primary" *ngIf="!isUserCustomerServiceExecutive && active == 1" (click)="submitCustomers()"
        [disabled]="!isCustomerSubmitButtonEnabled">Submit</button>
    </mat-card-actions>
  </mat-card>


</form>